export default __webpack_public_path__ + "static/media/testallyLogo-removebg.a425fb8c.png";